import { useEffect, useState } from 'react';
import _ from 'lodash';

// switch house ads this often
const DEFAULT_DELAY_SECONDS = 60;

type TUseListCarouselParams = {
  delaySeconds: number;
};

export function useListCarousel<T>(list: T[], userParams?: TUseListCarouselParams) {
  const [listIndex, setListIndex] = useState(0);

  const params: TUseListCarouselParams = {
    delaySeconds: DEFAULT_DELAY_SECONDS,
    ...userParams
  };

  useEffect(() => {
    if (list?.length > 0) {
      const handler = setInterval(() => {
        setListIndex((listIndex + 1) % list.length);
      }, 1000 * params.delaySeconds);

      return () => {
        clearInterval(handler);
      };
    }
  }, [list]);

  if (!list || list.length === 0) {
    return null;
  }

  return list[listIndex];
}
